import { CategoryComponent } from "./category/category.component";
import { ProductComponent } from "./product/product.component";
import { GalleryComponent } from "./gallery/gallery.component";

export default {
  CategoryComponent,
  ProductComponent,
  GalleryComponent,
};

export const COMPONENTS = [
  CategoryComponent,
  ProductComponent,
  GalleryComponent,
];
